
import { MaskInputType } from "../../../../../../components/finalForms/libs/data/formControlTypes";
import { FormFieldTypes } from "../../../../../../components/finalForms/libs/data/formFieldType";

const initState = {
  dtDateEffective: null,
  dtDateTermination: null,
  dtOriginalTerminationDate: null,
  lContractTypeKey: null,
  lInstallmentTypeID: null,
  bServicePlan: false,
  lServicePlanTermKey: 0,
  bManualSchedule: false,
  bTaxExempt: false,
  pbShowConsumptionOnPortal: false,
  bCostsPerDepartment: false,
  bUnlimitedProducts: false,
  bSharedRisk: false,
  dtSharedRiskStartDate: null,
  dblAmtTotal: 0,
  dblContractDepartmentTotal: "",
  dblContractBillScheduleToatl: "",
  sRenewedContract: "",
  nSharedRiskPercentage: null,
  sPurchaseOrder: "",
  lSalesRepKey: null,
  dblAmtInvoiced: 0,
  lSalesTaxKey: 0,
  SalesTaxKey: null,
  lPaymentTermsKey: null,
};

export const specificationsConfig = {
  name: "Specifications",
  initialState: initState,
  section: [
    {
      sectionId: "specificationsSection",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-4 col-md-4 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "dtDateEffective",
              label: "Effective Date :",
              Field_Name: "Effective Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "dtDateEffective",
              fieldSetting: {
                placeholder: "Select Effective Date",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },

            {
              id: "dtOriginalTerminationDate",
              label: "Original Term Date :",
              Field_Name: "Original Term Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "dtOriginalTerminationDate",
              fieldSetting: {
                placeholder: "Select Original Term Date",
                allowSpace: true,
              },
           
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "dtDateTermination",
              label: "Termination Date :",
              Field_Name: "Termination Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "dtDateTermination",
              fieldSetting: {
                placeholder: "Select Termination Date",
                allowSpace: false,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lContractTypeKey",
              label: "Contract Type :",
              Field_Name: "Contract Type",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lContractTypeKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Contract Type",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lInstallmentTypeID",
              label: "Invoice Frequency:",
              Field_Name: "Invoice Frequency",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lInstallmentTypeID",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Invoice Frequency",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },

            {
              id: "bServicePlan",
              label: "",
              Field_Name: "Service Plan",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bServicePlan",
              fieldSetting: {
                placeholder: "",
                subTitle:"Service Plan :"
              },
              style: {
                containerCss: "col-lg-6 col-md-6 col-6 double-label-sec mb-2 ",
              },
            },

            {
              id: "lServicePlanTermKey",
              Field_Name: "Service Plan",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lServicePlanTermKey",
              fieldSetting: {
                isEnableOnChange: false,
                placeholder: "Select Service Plan",
                options: [],
              },
              style: {
                containerCss: "col-lg-6 col-md-12 col-12 mb-2 ",
              },
            },


            {
              id: "dblAmtTotal",
              label: "Contract Total : ",
              Field_Name: "Contract Total",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblAmtTotal",
              fieldSetting: {
                placeholder: "Enter Contract Total",
                allowSpace: true,
              },
              
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "dblContractDepartmentTotal",
              label: "Departments Total : ",
              Field_Name: "Departments Total",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblContractDepartmentTotal",
              fieldSetting: {
                placeholder: "Enter Departments Total",
                allowSpace: true,
                isDisable: true,
              },
              validation: [],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "dblContractBillScheduleToatl",
              label: "Schedule Total : ",
              Field_Name: "Schedule Total",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblContractBillScheduleToatl",
              fieldSetting: {
                placeholder: "Enter Schedule Total",
                allowSpace: true,
                isDisable: true,
              },
              validation: [],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "bManualSchedule",
              label: "",
              Field_Name: "Manual Schedule status",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bManualSchedule",
              fieldSetting: {
                placeholder: "",
                subTitle:"Manual Schedule :"
              },
              style: {
                containerCss: "col-lg-6 col-md-6 col-6 double-label-sec mb-2 ",
              },
            },
          ],
        },
      ],
    },
    {
      sectionId: "specificationsSection1",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-4 col-md-4 pr-5",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "dblAmtInvoiced",
              label: "Invoice Amount : ",
              Field_Name: "Invoice Amount",
              fieldType: FormFieldTypes.INPUT,
              dataField: "dblAmtInvoiced",
              fieldSetting: {
                placeholder: "Enter Invoice Amount",
                allowSpace: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lSalesTaxKey",
              label: "Sales Tax:",
              Field_Name: "Sales Tax",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lSalesTaxKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Sales Tax",
                options: [],
                isDisable: true,
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-8 col-md-8 col-8 mb-2 ",
              },
            },
            {
              id: "bTaxExempt",
              label: "Tax Exempt",
              Field_Name: "Tax Exempt",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bTaxExempt",
              fieldSetting: {
                placeholder: "   ",
              },
              style: {
                containerCss: "col-lg-4 col-md-4 col-4 mb-2 ",
              },
            },
            {
              id: "lSalesRepKey",
              label: "Sales Rep:",
              Field_Name: "Sales Rep",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lSalesRepKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Sales Rep",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "bCostsPerDepartment",
              label: "",
              Field_Name: "po",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bCostsPerDepartment",
              fieldSetting: {
                placeholder: "   ",
                subTitle: "PO :"
              },
              style: {
                containerCss: "col-lg-6 col-md-6 col-6 double-label-sec mb-2 ",
              },
            },
            {
              id: "sPurchaseOrder",
              label: "Purchase Order: ",
              Field_Name: "Purchase Order",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sPurchaseOrder",
              fieldSetting: {
                placeholder: "Enter Purchase Order",
                allowSpace: true,
                maxLength:20
              },
           //   validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "lPaymentTermsKey",
              label: "Payment Terms:",
              Field_Name: "Payment Terms",
              fieldType: FormFieldTypes.SELECT,
              dataField: "lPaymentTermsKey",
              fieldSetting: {
                isEnableOnChange: true,
                placeholder: "Select Payment Terms",
                options: [],
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },

            {
              id: "sRenewedContract",
              label: "Renewal Contract: ",
              Field_Name: "Renewal Contract",
              fieldType: FormFieldTypes.INPUT,
              dataField: "sRenewedContract",
              fieldSetting: {
                placeholder: "Enter Renewal Contract",
                allowSpace: true,
                isDisable: true,
              },
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "bUnlimitedProducts",
              label: "",
              Field_Name: "Unlimited Products",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bUnlimitedProducts",
              fieldSetting: {
                placeholder: "   ",
                subTitle:"Unlimited Products :"
              },
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 double-label-sec mb-2 big-checkbox-label",
              },
            },
            {
              id: "pbShowConsumptionOnPortal",
              label: "",
              Field_Name: "Consumptionon Portal",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "pbShowConsumptionOnPortal",
              fieldSetting: {
                placeholder: "   ",
                subTitle:"Consumption on Portal : "
              },
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 double-label-sec mb-2 big-checkbox-label",
              },
            },
          ],
        },
      ],
    },

    {
      sectionId: "specificationsSection2",
      title: "Specifications Details",
      row: {},
      style: {
        sectionStyle: "col-lg-4 col-md-4",
      },
      wrapperTemplate: <div className="row"></div>, // Wrapper HTML or Component
      rowGroup: [
        {
          groupLabel: "Specifications Information", // Group for contact fields
          style: {
            groupStyle: "col-lg-12 col-md-12 mb-2",
          },
          groupWrapper: <div className="form-card row"></div>,
          fields: [
            {
              id: "bSharedRiskTitle",
              label: "",
              Field_Name: "Shared Risk",
              fieldType: FormFieldTypes.MAINFORMTITLE,
              dataField: "bSharedRiskTitle",
              fieldSetting: {
                placeholder: "   ",
                formTitle:"Shared Risk : "
              },
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
            {
              id: "bSharedRisk",
              label: "",
              Field_Name: "Applicable",
              fieldType: FormFieldTypes.CHECKBOX,
              dataField: "bSharedRisk",
              fieldSetting: {
                placeholder: "   ",
                subTitle:"Applicable : "
              },
              style: {
                containerCss: "col-lg-4 col-md-4 col-4 double-label-sec mb-2 ",
              },
            },
            {
              id: "nSharedRiskPercentage",
              label: "Percentage: ",
              Field_Name: "Percentage",
              fieldType: FormFieldTypes.MASKINPUT,
              dataField: "nSharedRiskPercentage",
              fieldSetting: {
                placeholder: "00.00%",
                masking: {
                  isMasking: true,
                  showMask: true,
                  maskFormat: "__.__%",
                  maskPlaceholder: "",
                  maskReplacement: { _: /\d/ },
                  maskType: MaskInputType.NUMBER,
                  isDisable: true,
                },
              },
              validation: [{ type: "require" }],
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 validation-left-0",
              },
            },
            {
              id: "dtSharedRiskStartDate",
              label: "Start Date :",
              Field_Name: "Start Date",
              fieldType: FormFieldTypes.DATEPICKER,
              dataField: "dtSharedRiskStartDate",
              fieldSetting: {
                placeholder: "Select Start Date",
                allowSpace: true,
                isDisable: true,
              },
              style: {
                containerCss: "col-lg-12 col-md-12 col-12 mb-2 ",
              },
            },
          ],
        },
      ],
    },
  ],
};
